import React from 'react'
import spark from "../../assets/spark.webp"
import panda from "../../assets/panda.webp"
import zameen from "../../assets/zameen.webp"
import infinix from "../../assets/infinix.webp"
import metro from "../../assets/metro.webp"
import baitUlIslam from "../../assets/bait-ul-islam.webp"
import mobil from "../../assets/mobil.webp"
import audionic from "../../assets/audionic.webp"
import golootlo from "../../assets/golootlo.webp"
import hsj from "../../assets/hsj.webp"
import unifood from "../../assets/unifood.webp"
import zong from "../../assets/zong.webp"
import optp from "../../assets/optp.webp"
import imtiaz from "../../assets/imtiaz.webp"
import tecno from "../../assets/tecno.webp"
import alGhafoor from "../../assets/AlGhafoor.png"
import kg from "../../assets/kg.webp"
import igloo from "../../assets/igloo.webp"
import foodPanda from "../../assets/foodpanda.webp"
import hascol from "../../assets/hascol.webp"
import urduflix from "../../assets/urduflix.webp"
import inverex   from "../../assets/inverex.webp"
import jade   from "../../assets/jade.webp"
import machiyara   from "../../assets/machiyara.webp"
import qlink   from "../../assets/qlink.webp"
import gfs   from "../../assets/gfs.webp"
import volka   from "../../assets/volka.webp"


const Partner = () => {
    
    const  logo = [
        foodPanda,inverex, spark, zameen,tecno,urduflix,infinix,optp,mobil, metro,
        imtiaz, alGhafoor, baitUlIslam, golootlo,hsj, audionic, jade,machiyara,
        igloo,zong, qlink,unifood,kg,hascol, gfs, volka,
         panda, 
        //    itel,
        
          
         
        //  paragon , ali,
          
        
    ]


    return (
    <div className='mt-4'>
      <div style={{width:"50%"}} className='text-white border-r h-20 mb-8'></div>
      <p className='text-white flex justify-center'>TRUSTED PARTNERS</p>
      <h2 className='border-l-0 pl-0 text-center'>
        VWRAP <span>360 CLIENTS</span>
      </h2>

     <div id='partners' className='flex justify-center px-20 '>
        <div id='logo-container'>
            {
                logo.map((item)=>{
                    return(
                        <span>
                            <img src={item} alt='vwrap'/>
                        </span>
                    )
                })
            }
        </div>

     </div>
        <div className='h-10 w-full'></div>

    </div>
  )
}

export default Partner
